import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertCircle, Smartphone, ArrowRight, Info } from 'lucide-react';

export default function StripeConnectRefresh() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [hasAttemptedRedirect, setHasAttemptedRedirect] = useState(false);

  useEffect(() => {
    // Detect mobile device
    const mobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobile(mobile);

    if (mobile) {
      // Try to open the app using deep link
      const deepLink = 'flexyswap://stripe-connect-refresh';
      
      // Attempt to open the app
      window.location.href = deepLink;
      setHasAttemptedRedirect(true);

      // Fallback: if app doesn't open, redirect to web wallet after delay
      setTimeout(() => {
        navigate('/wallet/withdrawal-account', { replace: true });
      }, 5000);
    } else {
      // For desktop/web, redirect to withdrawal account setup page
      setTimeout(() => {
        navigate('/wallet/withdrawal-account', { replace: true });
      }, 2000);
    }
  }, [navigate]);

  const handleOpenApp = () => {
    if (isMobile) {
      window.location.href = 'flexyswap://stripe-connect-refresh';
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-orange-50 to-yellow-50 px-4">
      <div className="w-full max-w-md text-center">
        {/* Info Icon */}
        <div className="mb-6 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 animate-pulse rounded-full bg-orange-400 opacity-20"></div>
            <AlertCircle className="relative h-24 w-24 text-orange-600" />
          </div>
        </div>

        {/* Message */}
        <h1 className="mb-3 text-3xl font-bold text-gray-900">
          {t('wallet.stripeConnectRefresh.additionalInfoRequired')}
        </h1>
        
        <div className="mb-6 rounded-lg bg-orange-100 p-4 text-left">
          <div className="mb-2 flex items-start gap-2">
            <Info className="mt-0.5 h-5 w-5 flex-shrink-0 text-orange-600" />
            <p className="text-sm text-orange-900">
              {t('wallet.stripeConnectRefresh.completeSetup')}
            </p>
          </div>
        </div>

        {/* Mobile App Return Message */}
        {isMobile && (
          <div className="mb-8 rounded-2xl bg-white p-6 shadow-lg">
            <div className="mb-4 flex justify-center">
              <div className="rounded-full bg-blue-100 p-4">
                <Smartphone className="h-8 w-8 text-blue-600" />
              </div>
            </div>
            <h2 className="mb-2 text-xl font-semibold text-gray-900">
              {t('wallet.stripeConnectReturn.returnToMobileApp')}
            </h2>
            <p className="mb-4 text-sm text-gray-600">
              {t('wallet.stripeConnectReturn.appWillOpen')}
            </p>
            <button
              onClick={handleOpenApp}
              className="inline-flex items-center gap-2 rounded-full bg-blue-600 px-6 py-3 font-semibold text-white transition hover:bg-blue-700 active:scale-95"
            >
              {t('wallet.stripeConnectReturn.openApp')}
              <ArrowRight className="h-5 w-5" />
            </button>
          </div>
        )}

        {/* Web Fallback */}
        {!isMobile && (
          <div className="rounded-lg bg-white p-4 text-sm text-gray-600">
            {t('wallet.stripeConnectRefresh.redirectingToSetup')}
          </div>
        )}
      </div>
    </div>
  );
}

